import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex align-items-center justify-content-center"
}
const _hoisted_2 = { class: "anim" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted text-center" }, "Подождите идет загрузка данных.", -1)
const _hoisted_5 = { class: "w-full flex c-header" }
const _hoisted_6 = { class: "flex w-6" }
const _hoisted_7 = { class: "flex justify-content-end w-2" }
const _hoisted_8 = { class: "flex justify-content-end w-2" }
const _hoisted_9 = {
  class: "flex justify-content-end w-2",
  style: {"padding-right":"0.5rem"}
}
const _hoisted_10 = { class: "flex w-full p-header" }
const _hoisted_11 = { class: "flex justify-content-end w-2" }
const _hoisted_12 = { class: "flex justify-content-end w-2" }
const _hoisted_13 = {
  class: "flex justify-content-end w-2",
  style: {"padding-right":"0.5rem"}
}
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = { class: "clip pl-6" }
const _hoisted_16 = { class: "flex w-full justify-content-end" }
const _hoisted_17 = { class: "flex w-full justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lottie_animation = _resolveComponent("lottie-animation")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_ctx.progress)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lottie_animation, {
            ref: "anim",
            loop: true,
            autoPlay: true,
            animationData: require('@/assets/animations/progress.json')
          }, null, 8, ["animationData"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Project.Header')), 1),
        _createVNode(_component_DataTable, {
          class: "p-datatable-sm projects mt-5",
          value: _ctx.projects,
          showGridlines: false,
          expandedRows: _ctx.expandedRows,
          "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expandedRows) = $event)),
          dataKey: "id",
          paginator: true,
          rows: 10,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
          rowsPerPageOptions: [10,20,50],
          responsiveLayout: "scroll",
          rowClass: _ctx.rowClass,
          sortField: "createDate",
          sortOrder: -1,
          currentPageReportTemplate: "{first} - {last} : {totalRecords}"
        }, {
          loading: _withCtx(() => [
            _hoisted_4
          ]),
          expansion: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_DataTable, {
                value: slotProps.data.documents,
                responsiveLayout: "scroll",
                dataKey: "id",
                rowClass: _ctx.documentRow,
                class: "document"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    style: {"min-width":"3rem"},
                    class: "noflex"
                  }),
                  _createVNode(_component_Column, {
                    field: "name",
                    class: "noflex w-6"
                  }, {
                    body: _withCtx(({data}) => [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(data.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "size",
                    class: "noflex w-2"
                  }, {
                    body: _withCtx(({data}) => [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatSize(data.size)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "duration",
                    class: "noflex w-2"
                  }, {
                    body: _withCtx(({data}) => [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatSeconds(data.duration)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "createDate",
                    class: "noflex w-2"
                  }, {
                    body: _withCtx(({data}) => []),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["value", "rowClass"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              expander: true,
              headerStyle: "width: 3rem",
              class: "noflex"
            }),
            _createVNode(_component_Column, {
              field: "name",
              class: "noflex"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('Project.Title')), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('Project.Size')), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('Project.Time')), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('Project.Date')), 1)
                ])
              ]),
              body: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex justify-content-start w-6", {'pro-title' : data.stenogramType == 'stenogramPro'}])
                  }, _toDisplayString(data.name), 3),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatSize(data.projectSize)), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatSeconds(data.projectDuration)), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatDate(data.createDate)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "expandedRows", "rowClass"])
      ]))
}